import React from 'react';

import { Form, Button } from "react-bootstrap";

import Belt from '../components/Belt';
import BeltLogged from '../components/BeltLogged';
import Footer from '../components/Footer';
import history from "../components/history";
import DateTimeNow from "../utils/DateTimeNow";

import ValidationFormField from "../utils/ValidationFormField";
import MailCooperation from "../mailNotification/MailCooperation";

class CooperationPage extends React.Component {

  mailData = {
    clubName: '',
    phone: '',
    email: '',
    description: ''
  };


  constructor(props) {
    super(props);

    this.state = {
      title: "Współpraca - RezerwujKort.pl",
      item: this.mailData,
      logInfo: "LogDebug __" + DateTimeNow() + "__ CooperationPage ",
      isError: {
        clubName: '',
        phone: '',
        email: '',
        description: ''
      }
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    document.title = this.state.title
  }

  handleChange(event) {

    const target = event.target;
    const value = target.value;
    const name = target.name;

    let item = { ...this.state.item };
    item[name] = target.value;

    this.setState({ item: item });

    this.fieldValidation(name, value);
  }

  async handleSubmit(event) {

    event.preventDefault();

    for (var key in this.state.item) {
      this.fieldValidation(key, this.state.item[key]);
    }

    if (ValidationFormField.formValid(this.state.isError)) {

      this.state.mailResponseData = await MailCooperation(this.state.item);

      history.push('/info', "Wiadomość została wysłana");
      window.location.reload();
    }
  }

  fieldValidation(name, value, compareValue) {

    let isError = { ...this.state.isError };

    switch (name) {
      case "clubName":
        isError.clubName = ValidationFormField.validClassName("Nazwa klubu", value);
        break;
      case "phone":
        isError.phone = ValidationFormField.validPhone("Telefon", value);
        break;
      case "email":
        isError.email = ValidationFormField.validEmail("Email", value);
        break;
      case "description":
        isError.description = ValidationFormField.validLongDescription("Treść wiadomości", value);
        break;
      default:
        isError.password = "";
        break;
    }
    this.setState({
      isError,
      [name]: value
    })
    this.state.isError[name] = isError[name];
  }


  render() {

    const { item } = this.state;
    let isError = { ...this.state.isError };

    return (

      <div>

        <Belt />

        <BeltLogged />

        <div id="content">
          <div class="container">

            <div class="main-subpage">
              <div class="head">
                <img src={`/images/login.png`} />
                <p>Współpraca</p>
              </div>
              <div class="tenis-content-info">
                <span>
                  <br />

                  <b>Profesjonalna aplikacja dla klubów sportów rakietowych</b>
                  <br /><br />
                  Stworzona z myślą o klubach tenisowych, padelowych i squashowych, nasza aplikacja łączy intuicyjność obsługi z pełnym zestawem 
                  funkcji niezbędnych w nowoczesnym klubie.
                  <br /><br />
                  Zarządzaj rezerwacjami, kontroluj płatności, generuj raporty wykorzystania kortów i umożliwiaj logowanie wielu pracowników – 
                  wszystko w jednym miejscu i bez zbędnych komplikacji.
                  <br /><br />
                  Prosta w obsłudze, nawet dla osób z podstawową znajomością komputera, zapewnia komfort pracy i pełną kontrolę nad klubem.
                  <br /><br />
                  Produkt dedykowany klubom posiadającym minimum dwa korty, które chcą zwiększyć efektywność zarządzania i komfort użytkowników.
                  <br /><br />
                  POTRZEBUJESZ WIĘCEJ?
                  <br /><br />

                  - grafik dostępności kortów możemy umieścić na Twojej stronie internetowej
                  <br /><br />
                  - posiadamy narzędzia do organizowania lig i wydarzeń sportowych (<a href="">Przejdź do przykładowej ligi</a>),
                  <br /><br />
                  - jesteśmy elastyczni – jeżeli potrzebujesz wyłącznie programu do zarządzania (bez ogólnodostępnego grafiku), to możemy taki dla Ciebie przygotować
                  <br /><br />
                  - posiadamy aplikacje mobilną <a href="https://www.rezerwujkort.pl/aplikacja_mobilna">(Zobacz)</a>
                  {/* <br /><br />
                  - program „Rezerwator” możemy zainstalować w Twoim smartfonie, a rezerwację przygotować w systemie on-line */}

                  <br /><br />
                  Wypełnij formularz lub zadzwoń pod numer: 660 916 097. Udostępnimy Ci program abyś sam mógł sprawdzić jego możliwości.
                  <br /><br />
                  Zajrzyj również na stronę <a href="/o_nas">o nas</a>

                </span>
              </div>



              <div class="main-subpage-content subpage-contact">
                <Form onSubmit={this.handleSubmit} id="mail_sugestia">
                  <div class="form-err">
                    {/* {% if form_errors(form.nazwaklubu) != "" %}
                                          <tr><td colspan="6">{{ form_errors(form.nazwaklubu) }}</td> </tr>
                                  {#{% elseif form_errors(form.wojewodztwo) != "" %}
                                          <tr><td colspan="6">{{ form_errors(form.wojewodztwo) }}</td> </tr>
                                  {% elseif form_errors(form.miasto) != "" %}
                                          <tr><td colspan="6">{{ form_errors(form.miasto) }}</td> </tr>#}
                                  {% elseif form_errors(form.telefon) != "" %}
                                          <tr><td colspan="6">{{ form_errors(form.telefon) }}</td> </tr>
                                  {% elseif form_errors(form.emaile) != "" %}
                                          <tr><td colspan="6">{{ form_errors(form.emaile) }}</td> </tr>
                                  {#{% elseif form_errors(form.ilekortow) != "" %}
                                          <tr><td colspan="6">{{ form_errors(form.ilekortow) }}</td> </tr>#}
                                  {% elseif form_errors(form.dodatkoweinformacje) != "" %}
                                          <tr><td colspan="6">{{ form_errors(form.dodatkoweinformacje) }}</td> </tr>
                                  {% elseif form_errors(form) != "" %}
                                          <tr><td colspan="6">{{ form_errors(form) }}</td> </tr>
                                  {% endif %} */}
                  </div>
                  <div class="contact-item">
                    <label>Nazwa Klubu<span style={{ 'color': '#86b606' }}>*</span>:</label>
                    <Form.Group controlId="formGridAddress1">
                      <Form.Control
                        placeholder=""
                        id="clubName"
                        name="clubName"
                        value={item.clubName || ''}
                        onChange={this.handleChange}
                      />
                      {this.state.isError.clubName.length > 0 && (
                        <span className="invalid-feedback-contakt">{this.state.isError.clubName}</span>
                      )}
                    </Form.Group>
                  </div>
                  <div class="contact-item">
                    <label>Telefon<span style={{ 'color': '#86b606' }}>*</span>:</label>
                    <Form.Group controlId="formGridAddress1">
                      <Form.Control
                        placeholder=""
                        id="phone"
                        name="phone"
                        value={item.phone || ''}
                        onChange={this.handleChange}
                      />
                      {this.state.isError.phone.length > 0 && (
                        <span className="invalid-feedback-contakt">{this.state.isError.phone}</span>
                      )}
                    </Form.Group>
                  </div>
                  <div class="contact-item">
                    <label>E-mail<span style={{ 'color': '#86b606' }}>*</span>:</label>
                    <Form.Group controlId="formGridAddress1">
                      <Form.Control
                        placeholder=""
                        id="email"
                        name="email"
                        onChange={this.handleChange}
                      />
                      {this.state.isError.email.length > 0 && (
                        <span className="invalid-feedback-contakt">{this.state.isError.email}</span>
                      )}
                    </Form.Group>
                  </div>

                  <div class="contact-item">
                    <label>Treść<span style={{ 'color': '#86b606' }}>*</span>:</label>
                    <Form.Group controlId="formGridAddress1">
                      <Form.Control as="textarea"
                        placeholder=""
                        id="description"
                        name="description"
                        onChange={this.handleChange}
                      />
                      {this.state.isError.description.length > 0 && (
                        <span className="invalid-feedback-contakt">{this.state.isError.description}</span>
                      )}
                    </Form.Group>
                  </div>
                  <div class="contact-button">
                    <span class="register-confirm-alert">Pole oznaczone <span style={{ 'color': '#86b606' }}>*</span> są wymagane</span>
                    <span><input class="btn-more semibold" value="Wyślij" type="submit" /></span>

                  </div>
                </Form>

              </div>
            </div>
          </div>
        </div>
        <Footer />

      </div>

    );
  }
}

export default CooperationPage;
